export default __webpack_public_path__ + "static/media/LogoUserDash.b819120d.png";